export function parseModelTestStepsJson(raw) {
    if (!raw?.trim())
        return [];
    try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed
            .map((row) => {
            if (!row || typeof row !== "object")
                return null;
            const o = row;
            const id = String(o.id || "");
            const label = String(o.label || "");
            if (!id || !label)
                return null;
            const status = String(o.status || "ok");
            return {
                id,
                label,
                status,
                detail: o.detail != null ? String(o.detail) : null,
                at: o.at != null ? String(o.at) : null,
            };
        })
            .filter((s) => s != null);
    }
    catch {
        return [];
    }
}
export function mergeModelTestStep(steps, step) {
    const idx = steps.findIndex((s) => s.id === step.id);
    if (idx >= 0) {
        const next = [...steps];
        next[idx] = { ...next[idx], ...step, at: step.at ?? next[idx]?.at ?? new Date().toISOString() };
        return next;
    }
    return [...steps, { ...step, at: step.at ?? new Date().toISOString() }];
}
const JOB_STATUS_LABELS = {
    QUEUED: "Job in coda provider",
    RUNNING: "Generazione immagine in corso",
    COMPLETED: "Job completato — asset su S3",
    FAILED: "Job provider fallito",
    CANCELLED: "Job annullato",
    TIMED_OUT: "Job scaduto lato provider",
};
export function modelTestStepForJobStatus(status, progress) {
    const label = JOB_STATUS_LABELS[status] ?? `Stato job: ${status}`;
    const detail = progress != null && status === "RUNNING" ? `progress ${progress}%` : status;
    return {
        id: `job_status_${status}`,
        label,
        status: status === "COMPLETED"
            ? "ok"
            : status === "FAILED" || status === "CANCELLED" || status === "TIMED_OUT"
                ? "error"
                : "running",
        detail,
    };
}
